export function getdata() {
	let obj = {
		
			headData: [{
					title: "项目",
					prop:'title',
					
					width: "300px",
					custom: true,
				},
				{
					title: "行次",
					prop: "grade",
					custom: true,
					width: "100px"
				},
				{
					title:'本年累计金额',
					prop:'cwbbxqykjzz_2_x_1',
					
					width: "200px",
					custom: true,
				},
				{
					title:'本月金额',
					prop:'cwbbxqykjzz_2_x_2',
					
					width: "200px",
					custom: true,
				},
			],
			tableData: [{
					title: "一、营业收入",
					grade: "1",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					title: "减：营业成本",
					grade: "2",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "营业税金及附加",
					grade: "3",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：消费税",
					grade: "4",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "营业税",
					grade: "5",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_5_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_5_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "城市维护建设税",
					grade: "6",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_6_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_6_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "资源税",
					grade: "7",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_7_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_7_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "土地增值税",
					grade: "8",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_8_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_8_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "城镇土地使用税、房产税、车船税、印花税",
					grade: "9",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_9_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_9_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "教育费附加、矿产资源补偿费、排污费",
					grade: "10",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_10_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_10_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: " 销售费用",
					grade: "11",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_11_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_11_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：商品维修费",
					grade: "12",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "广告费和业务宣传费",
					grade: "13",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_13_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_13_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: " 管理费用",
					grade: "14",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：开办费",
					grade: "15",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "业务招待费",
					grade: "16",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "研究费用",
					grade: "17",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_17_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_17_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "财务费用",
					grade: "18",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_18_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_18_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：利息费用（收入以“-”号填列）",
					grade: "19",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_19_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_19_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "加：投资收益（损失以“-”号填列）",
					grade: "20",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "二、营业利润（亏损以“-”号填列）",
					grade: "21",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "加：营业外收入",
					grade: "22",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：政府补助",
					grade: "23",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_23_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_23_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "减：营业外支出",
					grade: "24",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_24_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_24_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：坏账损失",
					grade: "25",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_25_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_25_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "无法收回的长期债券投资损失",
					grade: "26",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_26_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_26_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "无法收回的长期股权投资损失",
					grade: "27",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_27_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_27_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "自然灾害等不可抗力因素造成的损失",
					grade: "28",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "税收滞纳金",
					grade: "29",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_29_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_29_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "三、利润总额（亏损总额以“-”号填列）",
					grade: "30",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_30_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_30_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "减：所得税费用",
					grade: "31",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_31_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_31_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "四、净利润（净亏损以“-”号填列）",
					grade: "32",
					disabledcwbbxqykjzz_2_x_1:false,
					disabledcwbbxqykjzz_2_x_2:false,
					cwbbxqykjzz_2_x_1: {
						cellCode:"cwbbxqykjzz_2_32_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_2_x_2: {
						cellCode:"cwbbxqykjzz_2_32_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				}
			]
		
	}
	return obj
}
